<template>
  <div class="under-label-div">
    <label class="form-control-label" :for="id"><slot></slot></label>
  </div>
</template>
<script>
export default {
  name: "shared-under-label",
  props: ["id"],
  mounted() {
    /* eslint-disable no-undef */
    $('[data-toggle="tooltip"]').tooltip();
  }
};
</script>

<style lang="scss" scoped>
.under-label-div {
  margin-top: -0.25em;
}
label {
  font-size: 0.75em;
  font-weight: bold;
  margin-bottom: 0.25em;
}
</style>
